"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentWebViewerV2 = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var webviewer_1 = __importDefault(require("@pdftron/webviewer"));
var core_1 = require("@material-ui/core");
var useForwardedRef_1 = require("../../utils/useForwardedRef");
var styles_1 = __importDefault(require("./styles"));
var atoms_1 = require("../../atoms");
var DEFAULT_STROKE_THICKNESS = 10;
var DEFAULT_FREE_TEXT_SIZE = '36pt';
var webViewerDefaults = Object.freeze({
    // NOTE: product key should be provided in each app
    path: '/webviewer',
    enableAnnotations: false,
    enableFilePicker: false,
    enableMeasurement: false,
    enableRedaction: false,
    disabledElements: [
        'ribbons',
        'menuButton',
        'leftPanelButton',
        'viewControlsButton',
        'searchButton',
        'toggleNotesButton',
    ],
});
/**
 * Utilized PDFTrons web viewer component to view/markup pdf and other documents
 */
exports.DocumentWebViewerV2 = react_1.default.forwardRef(function (_a, ref) {
    var _b = _a.webViewerOptions, webViewerOptions = _b === void 0 ? {} : _b, _c = _a.onViewerLoad, onViewerLoad = _c === void 0 ? function () { } : _c, _d = _a.onViewerLoadError, onViewerLoadError = _d === void 0 ? function () { } : _d;
    var classes = (0, styles_1.default)();
    // ref
    var internalRef = react_1.default.useRef(null);
    var forwardedRef = (0, useForwardedRef_1.useForwardedRef)(ref);
    var webViewerElement = forwardedRef || internalRef;
    var webViewerInstance = react_1.default.useRef();
    // state
    var _e = react_1.default.useState(true), loading = _e[0], setLoading = _e[1];
    // NOTE: once the web viewer is loaded we need to ignore changes to options
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var memoizedOptions = react_1.default.useMemo(function () { return webViewerOptions; }, []);
    react_1.default.useEffect(function () {
        // make sure we only initialize ONCE, when there is no instance set
        var shouldLoadWebViewer = webViewerElement.current && !webViewerInstance.current;
        if (shouldLoadWebViewer) {
            // call an async closure
            (function () { return __awaiter(void 0, void 0, void 0, function () {
                var webViewer, documentViewer, ex_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, (0, webviewer_1.default)(__assign(__assign({}, webViewerDefaults), memoizedOptions), webViewerElement.current)];
                        case 1:
                            webViewer = _a.sent();
                            documentViewer = webViewer.Core.documentViewer;
                            documentViewer.getTool('AnnotationCreateRectangle').setStyles(function () { return ({
                                StrokeThickness: DEFAULT_STROKE_THICKNESS,
                            }); });
                            documentViewer.getTool('AnnotationCreateRectangle2').setStyles(function () { return ({
                                StrokeThickness: DEFAULT_STROKE_THICKNESS,
                            }); });
                            documentViewer.getTool('AnnotationCreateRectangle3').setStyles(function () { return ({
                                StrokeThickness: DEFAULT_STROKE_THICKNESS,
                            }); });
                            documentViewer.getTool('AnnotationCreateRectangle4').setStyles(function () { return ({
                                StrokeThickness: DEFAULT_STROKE_THICKNESS,
                            }); });
                            documentViewer.getTool('AnnotationCreateFreeText').setStyles(function () { return ({
                                FontSize: DEFAULT_FREE_TEXT_SIZE,
                            }); });
                            documentViewer.getTool('AnnotationCreateFreeText2').setStyles(function () { return ({
                                FontSize: DEFAULT_FREE_TEXT_SIZE,
                            }); });
                            documentViewer.getTool('AnnotationCreateFreeText3').setStyles(function () { return ({
                                FontSize: DEFAULT_FREE_TEXT_SIZE,
                            }); });
                            documentViewer.getTool('AnnotationCreateFreeText4').setStyles(function () { return ({
                                FontSize: DEFAULT_FREE_TEXT_SIZE,
                            }); });
                            // FREE HAND
                            documentViewer.getTool('AnnotationCreateFreeHandHighlight').setStyles(function () { return ({
                                StrokeThickness: DEFAULT_STROKE_THICKNESS,
                            }); });
                            documentViewer.getTool('AnnotationCreateFreeHandHighlight2').setStyles(function () { return ({
                                StrokeThickness: DEFAULT_STROKE_THICKNESS,
                            }); });
                            documentViewer.getTool('AnnotationCreateFreeHandHighlight3').setStyles(function () { return ({
                                StrokeThickness: DEFAULT_STROKE_THICKNESS,
                            }); });
                            documentViewer.getTool('AnnotationCreateFreeHandHighlight4').setStyles(function () { return ({
                                StrokeThickness: DEFAULT_STROKE_THICKNESS,
                            }); });
                            documentViewer.getTool('AnnotationCreateFreeHand').setStyles(function () { return ({
                                StrokeThickness: DEFAULT_STROKE_THICKNESS,
                            }); });
                            documentViewer.getTool('AnnotationCreateFreeHand2').setStyles(function () { return ({
                                StrokeThickness: DEFAULT_STROKE_THICKNESS,
                            }); });
                            documentViewer.getTool('AnnotationCreateFreeHand3').setStyles(function () { return ({
                                StrokeThickness: DEFAULT_STROKE_THICKNESS,
                            }); });
                            documentViewer.getTool('AnnotationCreateFreeHand4').setStyles(function () { return ({
                                StrokeThickness: DEFAULT_STROKE_THICKNESS,
                            }); });
                            // LINE
                            documentViewer.getTool('AnnotationCreateLine').setStyles(function () { return ({
                                StrokeThickness: DEFAULT_STROKE_THICKNESS,
                            }); });
                            documentViewer.getTool('AnnotationCreateLine2').setStyles(function () { return ({
                                StrokeThickness: DEFAULT_STROKE_THICKNESS,
                            }); });
                            documentViewer.getTool('AnnotationCreateLine3').setStyles(function () { return ({
                                StrokeThickness: DEFAULT_STROKE_THICKNESS,
                            }); });
                            documentViewer.getTool('AnnotationCreateLine4').setStyles(function () { return ({
                                StrokeThickness: DEFAULT_STROKE_THICKNESS,
                            }); });
                            // POLYLINE
                            documentViewer.getTool('AnnotationCreatePolyline').setStyles(function () { return ({
                                StrokeThickness: DEFAULT_STROKE_THICKNESS,
                            }); });
                            documentViewer.getTool('AnnotationCreatePolyline2').setStyles(function () { return ({
                                StrokeThickness: DEFAULT_STROKE_THICKNESS,
                            }); });
                            documentViewer.getTool('AnnotationCreatePolyline3').setStyles(function () { return ({
                                StrokeThickness: DEFAULT_STROKE_THICKNESS,
                            }); });
                            documentViewer.getTool('AnnotationCreatePolyline4').setStyles(function () { return ({
                                StrokeThickness: DEFAULT_STROKE_THICKNESS,
                            }); });
                            // ARROW
                            documentViewer.getTool('AnnotationCreateArrow').setStyles(function () { return ({
                                StrokeThickness: DEFAULT_STROKE_THICKNESS,
                            }); });
                            documentViewer.getTool('AnnotationCreateArrow2').setStyles(function () { return ({
                                StrokeThickness: DEFAULT_STROKE_THICKNESS,
                            }); });
                            documentViewer.getTool('AnnotationCreateArrow3').setStyles(function () { return ({
                                StrokeThickness: DEFAULT_STROKE_THICKNESS,
                            }); });
                            documentViewer.getTool('AnnotationCreateArrow4').setStyles(function () { return ({
                                StrokeThickness: DEFAULT_STROKE_THICKNESS,
                            }); });
                            // ARC
                            documentViewer.getTool('AnnotationCreateArc').setStyles(function () { return ({
                                StrokeThickness: DEFAULT_STROKE_THICKNESS,
                            }); });
                            documentViewer.getTool('AnnotationCreateArc2').setStyles(function () { return ({
                                StrokeThickness: DEFAULT_STROKE_THICKNESS,
                            }); });
                            documentViewer.getTool('AnnotationCreateArc3').setStyles(function () { return ({
                                StrokeThickness: DEFAULT_STROKE_THICKNESS,
                            }); });
                            documentViewer.getTool('AnnotationCreateArc4').setStyles(function () { return ({
                                StrokeThickness: DEFAULT_STROKE_THICKNESS,
                            }); });
                            // ELLIPSE
                            documentViewer.getTool('AnnotationCreateEllipse').setStyles(function () { return ({
                                StrokeThickness: DEFAULT_STROKE_THICKNESS,
                            }); });
                            documentViewer.getTool('AnnotationCreateEllipse2').setStyles(function () { return ({
                                StrokeThickness: DEFAULT_STROKE_THICKNESS,
                            }); });
                            documentViewer.getTool('AnnotationCreateEllipse3').setStyles(function () { return ({
                                StrokeThickness: DEFAULT_STROKE_THICKNESS,
                            }); });
                            documentViewer.getTool('AnnotationCreateEllipse4').setStyles(function () { return ({
                                StrokeThickness: DEFAULT_STROKE_THICKNESS,
                            }); });
                            // POLYGON
                            documentViewer.getTool('AnnotationCreatePolygon').setStyles(function () { return ({
                                StrokeThickness: DEFAULT_STROKE_THICKNESS,
                            }); });
                            documentViewer.getTool('AnnotationCreatePolygon2').setStyles(function () { return ({
                                StrokeThickness: DEFAULT_STROKE_THICKNESS,
                            }); });
                            documentViewer.getTool('AnnotationCreatePolygon3').setStyles(function () { return ({
                                StrokeThickness: DEFAULT_STROKE_THICKNESS,
                            }); });
                            documentViewer.getTool('AnnotationCreatePolygon4').setStyles(function () { return ({
                                StrokeThickness: DEFAULT_STROKE_THICKNESS,
                            }); });
                            // POLYGON CLOUD
                            documentViewer.getTool('AnnotationCreatePolygonCloud').setStyles(function () { return ({
                                StrokeThickness: DEFAULT_STROKE_THICKNESS,
                            }); });
                            documentViewer.getTool('AnnotationCreatePolygonCloud2').setStyles(function () { return ({
                                StrokeThickness: DEFAULT_STROKE_THICKNESS,
                            }); });
                            documentViewer.getTool('AnnotationCreatePolygonCloud3').setStyles(function () { return ({
                                StrokeThickness: DEFAULT_STROKE_THICKNESS,
                            }); });
                            documentViewer.getTool('AnnotationCreatePolygonCloud4').setStyles(function () { return ({
                                StrokeThickness: DEFAULT_STROKE_THICKNESS,
                            }); });
                            // DISTANCE
                            documentViewer.getTool('AnnotationCreateDistanceMeasurement').setStyles(function () { return ({
                                StrokeThickness: DEFAULT_STROKE_THICKNESS,
                            }); });
                            documentViewer.getTool('AnnotationCreateDistanceMeasurement2').setStyles(function () { return ({
                                StrokeThickness: DEFAULT_STROKE_THICKNESS,
                            }); });
                            documentViewer.getTool('AnnotationCreateDistanceMeasurement3').setStyles(function () { return ({
                                StrokeThickness: DEFAULT_STROKE_THICKNESS,
                            }); });
                            documentViewer.getTool('AnnotationCreateDistanceMeasurement4').setStyles(function () { return ({
                                StrokeThickness: DEFAULT_STROKE_THICKNESS,
                            }); });
                            // ARC MEASUREMENT
                            documentViewer.getTool('AnnotationCreateArcMeasurement').setStyles(function () { return ({
                                StrokeThickness: DEFAULT_STROKE_THICKNESS,
                            }); });
                            documentViewer.getTool('AnnotationCreateArcMeasurement2').setStyles(function () { return ({
                                StrokeThickness: DEFAULT_STROKE_THICKNESS,
                            }); });
                            documentViewer.getTool('AnnotationCreateArcMeasurement3').setStyles(function () { return ({
                                StrokeThickness: DEFAULT_STROKE_THICKNESS,
                            }); });
                            documentViewer.getTool('AnnotationCreateArcMeasurement4').setStyles(function () { return ({
                                StrokeThickness: DEFAULT_STROKE_THICKNESS,
                            }); });
                            // PERIMETER MEASUREMENT
                            documentViewer.getTool('AnnotationCreatePerimeterMeasurement').setStyles(function () { return ({
                                StrokeThickness: DEFAULT_STROKE_THICKNESS,
                            }); });
                            documentViewer.getTool('AnnotationCreatePerimeterMeasurement2').setStyles(function () { return ({
                                StrokeThickness: DEFAULT_STROKE_THICKNESS,
                            }); });
                            documentViewer.getTool('AnnotationCreatePerimeterMeasurement3').setStyles(function () { return ({
                                StrokeThickness: DEFAULT_STROKE_THICKNESS,
                            }); });
                            documentViewer.getTool('AnnotationCreatePerimeterMeasurement4').setStyles(function () { return ({
                                StrokeThickness: DEFAULT_STROKE_THICKNESS,
                            }); });
                            // AREA MEASUREMENT
                            documentViewer.getTool('AnnotationCreateAreaMeasurement').setStyles(function () { return ({
                                StrokeThickness: DEFAULT_STROKE_THICKNESS,
                            }); });
                            documentViewer.getTool('AnnotationCreateAreaMeasurement2').setStyles(function () { return ({
                                StrokeThickness: DEFAULT_STROKE_THICKNESS,
                            }); });
                            documentViewer.getTool('AnnotationCreateAreaMeasurement3').setStyles(function () { return ({
                                StrokeThickness: DEFAULT_STROKE_THICKNESS,
                            }); });
                            documentViewer.getTool('AnnotationCreateAreaMeasurement4').setStyles(function () { return ({
                                StrokeThickness: DEFAULT_STROKE_THICKNESS,
                            }); });
                            // ELLIPSE AREA MEASUREMENT
                            documentViewer.getTool('AnnotationCreateEllipseMeasurement').setStyles(function () { return ({
                                StrokeThickness: DEFAULT_STROKE_THICKNESS,
                            }); });
                            documentViewer.getTool('AnnotationCreateEllipseMeasurement2').setStyles(function () { return ({
                                StrokeThickness: DEFAULT_STROKE_THICKNESS,
                            }); });
                            documentViewer.getTool('AnnotationCreateEllipseMeasurement3').setStyles(function () { return ({
                                StrokeThickness: DEFAULT_STROKE_THICKNESS,
                            }); });
                            documentViewer.getTool('AnnotationCreateEllipseMeasurement4').setStyles(function () { return ({
                                StrokeThickness: DEFAULT_STROKE_THICKNESS,
                            }); });
                            // RECTANGLE AREA MEASUREMENT
                            documentViewer.getTool('AnnotationCreateRectangularAreaMeasurement').setStyles(function () { return ({
                                StrokeThickness: DEFAULT_STROKE_THICKNESS,
                            }); });
                            documentViewer.getTool('AnnotationCreateRectangularAreaMeasurement2').setStyles(function () { return ({
                                StrokeThickness: DEFAULT_STROKE_THICKNESS,
                            }); });
                            documentViewer.getTool('AnnotationCreateRectangularAreaMeasurement3').setStyles(function () { return ({
                                StrokeThickness: DEFAULT_STROKE_THICKNESS,
                            }); });
                            documentViewer.getTool('AnnotationCreateRectangularAreaMeasurement4').setStyles(function () { return ({
                                StrokeThickness: DEFAULT_STROKE_THICKNESS,
                            }); });
                            // set instance to a REF and not to state so that we don't re-instantiate
                            webViewerInstance.current = webViewer;
                            // callback with success
                            onViewerLoad(webViewer);
                            return [3 /*break*/, 3];
                        case 2:
                            ex_1 = _a.sent();
                            // callback with error
                            onViewerLoadError(ex_1);
                            return [3 /*break*/, 3];
                        case 3:
                            setLoading(false);
                            return [2 /*return*/];
                    }
                });
            }); })();
        }
    }, [memoizedOptions, onViewerLoad, onViewerLoadError, webViewerElement]);
    return ((0, jsx_runtime_1.jsxs)(core_1.Box, __assign({ className: classes.root }, { children: [loading ? ((0, jsx_runtime_1.jsx)(core_1.Box, __assign({ display: "flex", justifyContent: "center", alignItems: "center", alignContent: "center", width: "100%", height: "100%" }, { children: (0, jsx_runtime_1.jsxs)(core_1.Box, __assign({ display: "flex", flexDirection: "column", textAlign: "center", justifyContent: "center", alignItems: "center", width: "375px", height: "200px", className: classes.loadingIndicator }, { children: [(0, jsx_runtime_1.jsx)(atoms_1.LoadingIndicator, { loading: true, marginBottom: 2 }), (0, jsx_runtime_1.jsx)("div", { children: "Please wait while we load your document." })] })) }))) : null, (0, jsx_runtime_1.jsx)("div", { "data-testid": "webviewer", className: classes.inner, ref: webViewerElement, hidden: loading })] })));
});
